import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'roundToNearestHalf'
})

export class RoundToNearestHalfPipe implements PipeTransform {
  transform(value: number): any {
    return Math.round(value*2)/2;
  }
}



// WEBPACK FOOTER //
// ./src/services/round-to-nearest-half.pipe.ts